import { logger } from '@/helpers/logger';
import useSuGRTariffs from '@/hooks/useSuGRTariffs/useSuGRTariffs';
import LoadingModule from '../LoadingModule/LoadingModule';
import TariffComparison from '../TariffComparison/TariffComparison';
import type { RegioTariffWrapperProps } from './types';

const RegioTariffWrapper = ({
  configuratorUrl,
  city,
  cityKey,
  consumption,
  fallbackTariffs,
  lastUpdated,
  productType,
  zipCode,
  streetName,
  streetNumber,
}: RegioTariffWrapperProps) => {
  const requestData = {
    city,
    cityKey,
    zipCode,
    streetName,
    streetNumber,
    [productType]: consumption,
    productType,
  };

  const { data: responseData, isLoading, error } = useSuGRTariffs(requestData);

  if (isLoading) {
    return <LoadingModule handleEnterFrame={0} />;
  }

  if (error) {
    logger.error(error);
  }

  return (
    <TariffComparison
      configuratorUrl={configuratorUrl}
      consumption={consumption}
      lastUpdated={lastUpdated}
      tariffResponseData={responseData}
      fallbackTariffs={fallbackTariffs}
      zipCode={zipCode}
      productType={productType}
    />
  );
};

export default RegioTariffWrapper;
